import { Radio, HelpButton } from '@sapphire-react/core';
import styled from 'styled-components';
import type { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { RadioGroupField } from '../RadioGroupField';

type Props = {
  control: Control<any>;
  labelText?: string;
  tooltipText?: string;
  validationText?: string;
};

export enum PolarQuestion {
  No = '0',
  Yes = '1',
}

export function SecondaryApplicantInquiry({
  control,
  labelText,
  tooltipText,
  validationText,
}: Props) {
  const { t } = useTranslation();
  const secondaryApplicantInquiryRules = {
    required:
      validationText ??
      t('shared:personalInformation.inputs.coApplicant.requiredError'),
  };

  return (
    <RadioWrapper>
      <RadioGroupField
        control={control}
        orientation={'horizontal'}
        rules={secondaryApplicantInquiryRules}
        name={'secondaryApplicantExist'}
        label={
          labelText ?? t('shared:personalInformation.inputs.coApplicant.label')
        }
        contextualHelp={
          <HelpButton
            variant={'help'}
            aria-label={'Hjälp!'}
            contentBody={
              tooltipText ??
              t('shared:personalInformation.inputs.coApplicant.tooltip_new')
            }
          />
        }
      >
        <Radio
          value={PolarQuestion.Yes}
          data-test-id={'secondary-applicant-yes'}
          UNSAFE_style={{ display: 'flex' }}
        >
          {t('shared:ternary.Yes')}
        </Radio>
        <Radio
          value={PolarQuestion.No}
          data-test-id={'secondary-applicant-no'}
          UNSAFE_style={{ display: 'flex' }}
        >
          {t('shared:ternary.No')}
        </Radio>
      </RadioGroupField>
    </RadioWrapper>
  );
}

const RadioWrapper = styled.div`
  label {
    display: inline;
  }
`;
